module.exports = __webpack_public_path__ + "img/LegendOfChange_DG.e0fcae01.png";